webpackJsonp([80979221068063],{

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(13);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _reactHelmet = __webpack_require__(38);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _banner = __webpack_require__(26);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _responsiveMargin = __webpack_require__(27);
	
	var _responsiveMargin2 = _interopRequireDefault(_responsiveMargin);
	
	var _sitenav = __webpack_require__(28);
	
	var _sitenav2 = _interopRequireDefault(_sitenav);
	
	var _CharacterBio2PageHero402x = __webpack_require__(98);
	
	var _CharacterBio2PageHero402x2 = _interopRequireDefault(_CharacterBio2PageHero402x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return Glamor.createElement(
	    'div',
	    null,
	    Glamor.createElement(_reactHelmet2.default, { title: 'Man Ray | The Realist | Sarah Coleman' }),
	    Glamor.createElement(_banner2.default, { imageUrl: _CharacterBio2PageHero402x2.default }),
	    Glamor.createElement(_sitenav2.default, null),
	    Glamor.createElement(
	      _responsiveMargin2.default,
	      { css: { maxWidth: '640px' } },
	      Glamor.createElement(
	        'h6',
	        null,
	        'The Realist | Character Bios'
	      ),
	      Glamor.createElement(
	        'h2',
	        null,
	        'Man Ray'
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'You might recognize ',
	        Glamor.createElement(
	          'a',
	          { target: '_blank', href: 'http://www.getty.edu/art/collection/objects/54733/man-ray-le-violon-d\'ingres-ingres\'s-violin-american-1924/' },
	          'this 1924 photograph'
	        ),
	        ' of his. Or ',
	        Glamor.createElement(
	          'a',
	          { target: '_blank', href: 'http://www.getty.edu/art/collection/objects/37756/man-ray-larmes-tears-american-1930-to-1932/' },
	          'this one'
	        ),
	        '. The American visual artist Man Ray was a significant member of Dada and Surrealist art circles in New York and Paris, and was known for his stunning photography\u2014as well as his high-profile love affairs.'
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'Lesser known are the details of his early life, which he withheld. Man Ray, n\xE9e Emmanuel Radnitzky, was born in Philadelphia in 1890 to Russian Jewish immigrants. His family settled in Williamsburg, Brooklyn, where they eventually shortened their ethnic surname to Ray amidst anti-Semitism. Ray tried to distance himself from his parents\u2019 line of work\u2014his father was a professional tailor, his mother made children\u2019s clothes\u2014but evidence of garment tools, from flat irons to needles and thread, appear in much of his art. Perhaps best known is his 1921 readymade, ',
	        Glamor.createElement(
	          'a',
	          { target: '_blank', href: 'http://www.tate.org.uk/art/artworks/man-ray-cadeau-t07883' },
	          'The Gift'
	        ),
	        ', an iron lined with thumbtacks.'
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'Ray commenced his formal study of art as a teenager. He learned drafting techniques at the Brooklyn Boys\u2019 High School and frequented the city\u2019s art museums to study the work of Old Masters. Upon graduation he received\u2014but declined\u2014a scholarship to study architecture; he wanted to become a painter. Unfortunately his paintings garnered little interest. And while he didn\u2019t consider himself a photographer, he earned steady praise for his camera skills. Early in his career Ray made prints of the work of artist friends like ',
	        Glamor.createElement(
	          'a',
	          { target: '_blank', href: 'http://www.theartstory.org/artist-duchamp-marcel.htm' },
	          'Marcel Duchamp'
	        ),
	        ' and took a handful of portraits\u2014including one of Berenice Abbott, who later became his assistant. In 1921 he moved to Paris, where he met and photographed poet and playwright Jean Cocteau. The Frenchman was so impressed he brought his writer and musician friends to Ray\u2019s hotel room to pose for portraits, too. Around this time Ray also met artists\u2019 model ',
	        Glamor.createElement(
	          'a',
	          { target: '_blank', href: 'https://en.wikipedia.org/wiki/Alice_Prin' },
	          'Kiki de Montparnasse'
	        ),
	        ', who became his lover for most of the 1920s, and whom he also captured on film.'
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'Ray might have stayed a portrait photographer and sometime painter had it not been for a happy accident. One night in his darkroom, a sheet of photo paper he\u2019d put into the developer came up blank; he\u2019d forgotten to expose it. Ray writes in his 1963 autobiography ',
	        Glamor.createElement(
	          'a',
	          { target: '_blank', href: 'https://www.amazon.com/Self-Portrait-Man-Ray/dp/0141195509' },
	          Glamor.createElement(
	            'em',
	            null,
	            'Self Portrait'
	          )
	        ),
	        ' that, \u201Cmechanically,\u201D he placed a glass funnel, graduate and thermometer on the wet paper. \u201CI turned on the light; before my eyes an image began to form, not quite a simple silhouette of the objects as in a straight photograph, but distorted and refracted\u2026\u201D'
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'Photograms were not entirely new.\xA0',
	        Glamor.createElement(
	          'a',
	          { target: '_blank', href: 'https://www.metmuseum.org/toah/hd/tlbt/hd_tlbt.htm' },
	          'William Henry Fox Talbot'
	        ),
	        '\xA0created some of the first prints and nineteenth-century botanist\xA0',
	        Glamor.createElement(
	          'a',
	          { target: '_blank', href: 'https://en.wikipedia.org/wiki/Anna_Atkins' },
	          'Anna Atkins'
	        ),
	        '\xA0made blueprints from cyanotypes. Moreover, a year or two before Ray, German painter\xA0',
	        Glamor.createElement(
	          'a',
	          { target: '_blank', href: 'https://en.wikipedia.org/wiki/Christian_Schad' },
	          'Christian Schad'
	        ),
	        '\xA0experimented with photograms, calling his results Schadographs. Nonetheless, as Ray tells it, leader of the Dadaist movement ',
	        Glamor.createElement(
	          'a',
	          { target: '_blank', href: 'https://en.wikipedia.org/wiki/Tristan_Tzara' },
	          'Tristan Tzara'
	        ),
	        ' pronounced Ray\u2019s photograms \u201Cpure Dada creations\u201D and claimed them \u201Cfar superior to similar attempts\u201D like those of Schad. The so-called Rayographs were an instant hit. His montages\u2014random collections of unconnected objects like scissors, springs and filmstrips\u2014spoke to a modernist sensibility in which reality was haphazard and fractured. Ray was good at composition, too, and as\xA0this page\xA0shows, there was an elegance and beauty to his work. He went on to use human subjects in his Rayographs, including Gertrude Stein, James Joyce, and Elsa von Freytag-Loringhoven. He also created memorable Surrealist images like his celebrated\xA0',
	        Glamor.createElement(
	          'a',
	          { target: '_blank', href: 'http://www.getty.edu/art/collection/objects/54733/man-ray-le-violon-d\'ingres-ingres\'s-violin-american-1924/' },
	          'Le Violon d\u2019Ingres'
	        ),
	        '. In 1925, Ray appeared in the first\xA0Surrealist\xA0exhibition at the Galerie Pierre in Paris with Max Ernst, Joan Mir\xF3, and\xA0Pablo Picasso.'
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'Over the next half century, Ray worked across mediums, directing a number of avant-garde films and collaborating with his contemporaries, especially Duchamp. And while his photographic work continued to please critics, Ray always thought himself a painter.'
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'Man Ray died in 1976 of a lung infection, but his influence endures. The latest artist to pay tribute to him is German photographer\xA0Thomas Ruff, who\xA0recently exhibited\xA0his digital photograms at the\xA0David Zwirner Gallery\xA0New York.'
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'In November 2017, Christie\u2019s France sold Ray\u2019s photograph \u201CNoir et Blanche, 1926\u201D for over $3 million, establishing a new world record for the sale of a classic photograph.'
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-the-realist-man-ray-js-feeaa52ca9d7e28bba4e.js